import { Provider, system, Toaster } from '@welbe/design-system';
import { AlertUserConsentData, ToastProvider } from '@welbe/web-design-system';
import { Amplify } from 'aws-amplify';
import { AuthProvider } from 'contexts/Auth';
import { BrokersProvider } from 'contexts/Brokers/Brokers';
import { CsatProvider } from 'contexts/CsatProvider';
import { FeatureFlagProvider } from 'contexts/FeatureFlagProvider';
import { GlobalProvider } from 'contexts/Global';
import { I18nProvider } from 'contexts/I18nProvider';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes } from 'routes';
import GlobalStyle from 'styles/global';
import { dataDogInit } from 'trackApp';
import { config } from './aws-exports';
import 'react-phone-number-input/style.css';

dataDogInit();
Amplify.configure(config);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
const root = createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<Router>
			<Provider value={system('blue')}>
				<ToastProvider
					toastOptions={{
						position: 'top-right',
						duration: 5000,
					}}
				>
					<Toaster />
					<AlertUserConsentData />
					<AuthProvider>
						<CsatProvider>
							<FeatureFlagProvider>
								<GlobalProvider>
									<I18nProvider>
										<GlobalStyle />
										<BrokersProvider>
											<Routes />
										</BrokersProvider>
									</I18nProvider>
								</GlobalProvider>
							</FeatureFlagProvider>
						</CsatProvider>
					</AuthProvider>
				</ToastProvider>
			</Provider>
		</Router>
	</React.StrictMode>,
);
